import React, { useMemo, useState } from 'react';

import { useSearch, useTranslate } from '../../../../../../hooks';
import { useNavigate } from 'react-router';
import { useGetTableLayout } from '../../../../hooks';
import { useConfigDelete, useConfigEdit, useConfigList } from '../../../../api';

import { baseDateFormatting } from '../../../../../../helpers/utils';
import { CONFIG_ID } from '../../../utils';

import DefaultTableBodyCell from '../../../../../../components/table/DefaultTableBodyCell';
import { DateField, Table } from '../../../../../../components';
import LoaderCotainer from '../../../components/LoaderCotainer';
import { Modal } from '@mui/material';
import SearchEmpPortaMenuSeaction from './components/SearchEmpPortaMenuSeaction';
import ActionepmField from './components/ActionepmField';
import EditEmpPortaMenuType from './components/EditEmpPortaMenuType';
import { useMenuConfigList } from './api/use-menu-config-list';
import { useMenuConfigDelete } from './api/use-delete-menu-config';

function EmpportalMenu() {
  const { translate } = useTranslate();
  const navigate = useNavigate();
  const [titleSearch, setTitleSearch] = useSearch('');
  const { layout } = useGetTableLayout({ type: 1 });

  const { data, isLoading, count, refetch } = useMenuConfigList({
    params: { name: titleSearch },
  });
  const { deleteConfig, isDeleting } = useMenuConfigDelete({
    params: { configId: CONFIG_ID?.assetType },
  });
  const onDelete = ({ data }) => deleteConfig(data?.id).then(() => refetch());

  //table columns config
  const columns = useMemo(
    () => [
      {
        name: 'typeId',
        label: translate('Type Id'),
        options: {
          customBodyRender: (value) => {
            return <DefaultTableBodyCell value={value} />;
          },
        },
      },
      {
        name: 'name',
        label: translate('Name'),
        options: {
          customBodyRender: (value) => {
            return <DefaultTableBodyCell value={value} />;
          },
        },
      },
      {
        name: 'createdAt',
        label: translate('Created At'),
        options: {
          customBodyRender: (value) => {
            return <DateField value={value} format={baseDateFormatting} />;
          },
        },
      },
      {
        name: 'updatedAt',
        label: translate('Updated At'),
        options: {
          customBodyRender: (value) => {
            return <DateField value={value} format={baseDateFormatting} />;
          },
        },
      },
      {
        name: 'action',
        label: translate('Action'),
        options: {
          setCellHeaderProps: () => ({
            align: 'center',
            style: { fontWeight: '600' },
          }),
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const tableData = useMemo(
    () => {
      const res = data?.map((item) => {
        return {
          typeId: item?.id,
          name: item?.name,
          createdAt: item?.created_at,
          updatedAt: item?.updated_at,
          action: (
            <ActionepmField
              onReject={() => onDelete({ data: item })}
              isRejecting={isDeleting}
              className="justify-center"
              newCancelLayout={true}
            />
          ),
        };
      });

      return res;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, isDeleting],
  );

  const onCreate = () => {
    navigate('create', {
      state: { compEmpTypeList: data },
    });
  };

  return (
    <div>
      <SearchEmpPortaMenuSeaction
        handleSearchTitle={setTitleSearch}
        openAddDesignation={onCreate}
      />
      {isLoading ? (
        <LoaderCotainer />
      ) : (
        <div className="mt-4">
          <Table
            columns={columns}
            data={tableData || []}
            count={count}
            options={{ ...layout }}
          />
        </div>
      )}
    </div>
  );
}

export default EmpportalMenu;
